/**
 * Navbar chrome shared by every page: the scroll-progress hairline and the
 * "scrolled" state. Other modules can subscribe to the normalized progress.
 */
type Listener = (progress: number) => void;
const listeners = new Set<Listener>();

export function onScrollProgress(cb: Listener): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function initChrome(): () => void {
  const nav = document.querySelector<HTMLElement>(".nav-bar");
  const bar = document.querySelector<HTMLElement>(".home-progress i");
  let raf = 0;

  const update = () => {
    raf = 0;
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const p = Math.max(0, Math.min(1, window.pageYOffset / max));
    if (bar) bar.style.transform = `scaleX(${p})`;
    listeners.forEach((cb) => cb(p));
    if (nav) nav.classList.toggle("is-scrolled", window.pageYOffset > 24);
  };
  const schedule = () => {
    if (!raf) raf = window.requestAnimationFrame(update);
  };

  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule);
  update();

  return () => {
    window.removeEventListener("scroll", schedule);
    window.removeEventListener("resize", schedule);
    if (raf) window.cancelAnimationFrame(raf);
    if (bar) bar.style.transform = "scaleX(0)";
  };
}
